/**
 * @generated SignedSource<<93636e0a9d6a38440e104f27edebad23>>
 * @relayHash af385297d074541397a638adda466b13
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9ede461daef26804b41c57ed0da7b652a844f9ef52bccb77ba525204371454f3

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ProjectPanelQuery$variables = {
  ari: string;
};
export type ProjectPanelQuery$data = {
  readonly townsquare: {
    readonly project: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"ProjectLinks" | "ProjectOwner" | "ProjectPanelHeader" | "ProjectStartDate" | "ProjectStatus" | "ProjectTags" | "ProjectTargetDate" | "ProjectWorkTracked">;
    } | null | undefined;
  } | null | undefined;
};
export type ProjectPanelQuery = {
  response: ProjectPanelQuery$data;
  variables: ProjectPanelQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ari"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "ari",
    "variableName": "ari"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "name"
},
v4 = [
  {
    "concreteType": "TownsquareLinkEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "TownsquareLink",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "url"
          },
          (v3/*: any*/)
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ProjectPanelQuery",
    "selections": [
      {
        "concreteType": "TownsquareQueryApi",
        "kind": "LinkedField",
        "name": "townsquare",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "TownsquareProject",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "FragmentSpread",
                "name": "ProjectPanelHeader"
              },
              {
                "kind": "FragmentSpread",
                "name": "ProjectTags"
              },
              {
                "kind": "FragmentSpread",
                "name": "ProjectTargetDate"
              },
              {
                "kind": "FragmentSpread",
                "name": "ProjectStatus"
              },
              {
                "kind": "FragmentSpread",
                "name": "ProjectOwner"
              },
              {
                "kind": "FragmentSpread",
                "name": "ProjectLinks"
              },
              {
                "kind": "FragmentSpread",
                "name": "ProjectWorkTracked"
              },
              {
                "kind": "FragmentSpread",
                "name": "ProjectStartDate"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProjectPanelQuery",
    "selections": [
      {
        "concreteType": "TownsquareQueryApi",
        "kind": "LinkedField",
        "name": "townsquare",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "TownsquareProject",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "TownsquareIconURIs",
                "kind": "LinkedField",
                "name": "iconUrl",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareThemeURIs",
                    "kind": "LinkedField",
                    "name": "roundedSquare",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "dark"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "light"
                      }
                    ]
                  }
                ]
              },
              {
                "concreteType": "TownsquareTagConnection",
                "kind": "LinkedField",
                "name": "tags",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareTagEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "TownsquareTag",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v3/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "description"
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "endCursor"
                      }
                    ]
                  }
                ]
              },
              {
                "concreteType": "TownsquareTargetDate",
                "kind": "LinkedField",
                "name": "dueDate",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareTargetDateRange",
                    "kind": "LinkedField",
                    "name": "dateRange",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "start"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "end"
                      }
                    ]
                  }
                ]
              },
              {
                "concreteType": "TownsquareProjectState",
                "kind": "LinkedField",
                "name": "state",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "label"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "value"
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "picture"
                  }
                ]
              },
              {
                "concreteType": "TownsquareLinkConnection",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": (v4/*: any*/)
              },
              {
                "alias": "workTrackingLinks",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1
                  },
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "WORK_TRACKING"
                  }
                ],
                "concreteType": "TownsquareLinkConnection",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": "links(first:1,type:\"WORK_TRACKING\")"
              },
              {
                "kind": "ScalarField",
                "name": "startDate"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "9ede461daef26804b41c57ed0da7b652a844f9ef52bccb77ba525204371454f3",
    "metadata": {},
    "name": "ProjectPanelQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "376bc2cc9c8f9d18584371b92d230d0e";

export default node;
